import {
    IndustriesSelectMenu,
    useTrackedNavigate,
} from 'components/BreadCrumbs';
import styled from 'styled-components';

const IndustriesOnlyWrapper = styled.div`
    display: grid;
    grid-template-columns: calc((100% - 120px) / 4);
`;

function IndustriesOnlyBreadCrumbs({
    generateLocation,
    metrics,
    industriesQuery,
    ...props
}) {
    const onChange = useTrackedNavigate({ replace: true, generateLocation });

    return (
        <IndustriesOnlyWrapper>
            <IndustriesSelectMenu
                generateLocation={generateLocation}
                metrics={metrics}
                industriesQuery={industriesQuery}
                onChange={onChange}
                depth={1}
                selectOnly={true}
                {...props}
            />
        </IndustriesOnlyWrapper>
    );
}

export default IndustriesOnlyBreadCrumbs;
